import React from 'react';
import { ActingDetailQueryStepsResponse } from '@area-restrita/api-client/model/actingDetailQueryStepsResponse';

import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

import { isCheckedResponse } from './actingDetailsPresentation';

interface IProps {
  response: ActingDetailQueryStepsResponse;
}

const ActingResponseValue: React.FC<IProps> = ({ response }) => {
  const inputId = `acting-response-${response.id}`;

  if (response.type === 'checkbox') {
    return (
      <div className="flex items-center gap-2">
        <Checkbox
          id={inputId}
          checked={isCheckedResponse(response.value)}
          disabled
        />
        <Label htmlFor={inputId}>{response.name}</Label>
      </div>
    );
  }

  if (response.type === 'textarea') {
    return (
      <div className="grid gap-2">
        <Label htmlFor={inputId}>{response.name}</Label>
        <Textarea
          id={inputId}
          value={response.value ?? 'Não respondido'}
          readOnly
        />
      </div>
    );
  }

  return (
    <div className="grid gap-2">
      <Label htmlFor={inputId}>{response.name}</Label>
      <Input id={inputId} value={response.value ?? 'Não respondido'} readOnly />
    </div>
  );
};

export default ActingResponseValue;
